import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FbLogo from '../../assets/fb-logo-white.svg';
import config from '../../config/Constant';
import { FacebookAuthResponse } from '../../helpers/FacebookAuthResponse';
import { postRequest } from '../../helpers/apiHandler';
import useFacebookSDK from '../../hooks/useFacebookSDK';
import { showAlert } from '../../store/actions/alertAction';

const FacebookLoginButton = ({
  accessToken,
  onLoginSuccess,
  onLoginFailed,
  isGettingStarted = true,
  buttonText = 'Connect with Facebook',
}) => {
  const isFBInitialized = useFacebookSDK(process.env.REACT_APP_META_APP_ID);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const exchangeCode = (code) => {
    postRequest('/v2/whatsapp/exchange-code', { code }, accessToken.token, (res) => {
      if (res.success) {
        dispatch(showAlert('Successfully connected with WhatsApp Cloud!', 'success'));
        onLoginSuccess();
      } else {
        onLoginFailed();
        dispatch(showAlert(res.message, 'danger'));
      }
    });
  };

  const handleLogin = () => {
    if (isGettingStarted) {
      navigate('/dashboard/whatsapp/getting-started');
      return;
    }

    if (!isFBInitialized) {
      return;
    }

    window.FB.login((response) => {
      if (response.authResponse) {
        const fbAuthRes = new FacebookAuthResponse(response.authResponse);

        if (fbAuthRes.isValid()) {
          exchangeCode(fbAuthRes.getCode());
        }
      } else {
        console.log('User cancelled login or did not fully authorize.');
      }
    }, config.whatsapp_embedded_config);
  };

  return (
    <button className="fb-button" onClick={handleLogin} disabled={!isFBInitialized}>
      <img src={FbLogo} alt="Facebook Logo" /> {isFBInitialized ? buttonText : 'Loading...'}
    </button>
  );
};

export default FacebookLoginButton;
